import { isEmptyObject } from "_lib/utils/utils"

const Im = {
  state: () => ({
    cur_private_user: {}, // 当前私聊用户信息
    at_msg_id: null,
    msg_list: [], // 消息请求列表 放vuex做持久化，防止返回后闪现空列表
    recent_msg_count: 0, // 最近消息总数
    recent_msg_list: [], // 最近消息列表
    stranger_msg_list: [], // 最近消息列表-陌生人\
    unread_messages: [], //未读消息列表
    channelIMId: '', // 频道IM对应频道id
    IM_input_temp_msg: {}, // IM输入框临时消息
    now_edit_msg: {
      im: '',
      private: '',
      chat_group: '',
    }, // 当前正在编辑的消息
    team_active_count: 0,
    rich_text_com_inited: false, // 富文本组件是否初始化过
    reply_list_params: {}, // 回复列表参数
    feedback_reply_params: {}, // 反馈回复列表参数
    feedback_root_msg: null, // 反馈根消息
    cur_im_slow_mode_cd: 0, // 当前频道慢速模式cd
    timing_msg_list: [], // 定时消息列表
    edit_timing_msg: null, // 当前正在编辑的定时消息
    max_timing_msg_count: 3, // 最大定时消息数量
    cur_channel_new_msg_count: 0, // 当前语音频道新消息数量
    cur_group_chat: {}, // 当前群聊 与私聊互斥
    all_chat_group_notify_settings: {}, // 所有群聊通知设置
  }),
  getters: {
    cur_private_user: (state) => state.cur_private_user,
    at_msg_id: (state) => state.at_msg_id,
    msg_list: (state) => state.msg_list,
    recent_msg_count: (state) => state.recent_msg_count,
    recent_msg_list: (state) => state.recent_msg_list,
    stranger_msg_list: (state) => state.stranger_msg_list,
    unread_messages: (state) => state.unread_messages,
    channelIMId: (state) => state.channelIMId,
    IM_input_temp_msg: (state) => state.IM_input_temp_msg,
    now_edit_msg: (state) => state.now_edit_msg,
    team_active_count: (state) => state.team_active_count,
    rich_text_com_inited: (state) => state.rich_text_com_inited,
    reply_list_params: (state) => state.reply_list_params,
    feedback_reply_params: (state) => state.feedback_reply_params,
    feedback_root_msg: (state) => state.feedback_root_msg,
    cur_im_slow_mode_cd: (state) => state.cur_im_slow_mode_cd,
    timing_msg_list: (state) => state.timing_msg_list,
    edit_timing_msg: (state) => state.edit_timing_msg,
    max_timing_msg_count: (state) => state.max_timing_msg_count,
    cur_channel_new_msg_count: (state) => state.cur_channel_new_msg_count,
    cur_group_chat: (state) => state.cur_group_chat,
    all_chat_group_notify_settings: (state) => state.all_chat_group_notify_settings,
  },
  mutations: {
    SET_CUR_PRIVATE_USER (state, val) {
      if(!isEmptyObject(val)) {
        state.cur_group_chat = {}
      }
      state.cur_private_user = val
    },
    SET_AT_MSG_ID (state, id) {
      state.at_msg_id = id
    },
    SET_MSG_LIST (state, val) {
      state.msg_list = val
    },
    SET_MSG_LIST_RESP (state, val) {
      state.msg_list[val.index] && (state.msg_list[val.index].resp = val.value)
    },
    SET_MSG_LIST_RESP_TEXT (state, val) {
      state.msg_list[val.index]['resp_text'] = val.value
    },
    SET_RECENT_MSG_COUNT(state, val) {
      if (val < 0) {
        val = 0
      }
      state.recent_msg_count = val
    },
    SET_RECENT_MSG_LIST(state, val) {
      state.recent_msg_list = val
    },
    SET_STRANGER_MSG_LIST(state, val) {
      state.stranger_msg_list = val
    },
    SET_UNREAD_MESSAGES(state, val) {
      state.unread_messages = val
    },
    SET_CHANNEL_IM_ID(state, val) {
      state.channelIMId = val
    },
    SET_IM_INPUT_TEMP_MSG(state, val) {
      state.IM_input_temp_msg = val
    },
    SET_NOW_EDIT_MSG(state, val) {
      state.now_edit_msg = {
        ...state.now_edit_msg,
        ...val
      }
    },
    SET_TEAM_ACTIVE_COUNT(state, val) {
      state.team_active_count = val
    },
    SET_RICH_TEXT_COM_INITED(state, val) {
      state.rich_text_com_inited = val
    },
    SET_REPLY_LIST_PARAMS(state, val) {
      state.reply_list_params = val
    },
    SET_FEEDBACK_REPLY_PARAMS(state, val) {
      state.feedback_reply_params = val
    },
    SET_FEEDBACK_ROOT_MSG(state, val) {
      state.feedback_root_msg = val
    },
    SET_CUR_IM_SLOW_MODE_CD(state, val) {
      state.cur_im_slow_mode_cd = val
    },
    SET_TIMING_MSG_LIST(state, val) {
      state.timing_msg_list = val
    },
    SET_EDIT_TIMING_MSG(state, val) {
      state.edit_timing_msg = val
    },
    SET_MAX_TIMING_MSG_COUNT(state, val) {
      state.max_timing_msg_count = val
    },
    SET_CUR_CHANNEL_NEW_MSG_COUNT(state, val) {
      state.cur_channel_new_msg_count = val
    },
    SET_CUR_GROUP_CHAT(state, val) {
      if(!isEmptyObject(val)) {
        state.cur_private_user = {}
      }
      state.cur_group_chat = val
    }, 
    SET_ALL_CHAT_GROUP_NOTIFY_SETTINGS(state, val) {
      state.all_chat_group_notify_settings = val
    },
  },
  actions: {
    SET_CUR_GROUP_CHAT_PARAMS({ commit, state }, { key, val }) {
      commit('SET_CUR_GROUP_CHAT', {
        ...state.cur_group_chat,
        [key]: val
      })
    },
  }
}
export default Im